import classNames from "classnames";
import CheckIcon from "@mui/icons-material/Check";

export default function PiCheckbox(props: {
  checked: boolean;
  onToggle: (checked: boolean) => void;
  shape?: "square" | "rounded";
  disabled?: boolean;
}) {
  const { checked, onToggle, shape = "square", disabled = false } = props;

  return (
    <div
      className={classNames({
        "w-[20px] h-[20px] flex justify-center items-center": true,
        "cursor-pointer": !disabled,
        "cursor-not-allowed opacity-50": disabled,
        "text-white bg-creator-primary hover:bg-creator-primary-hover text-[16px]":
          checked && !disabled,
        "text-white bg-creator-primary text-[16px]": checked && disabled,
        "border-2 border-solid border-creator-primary": !checked && !disabled,
        "border-2 border-solid border-creator-border": !checked && disabled,
        "rounded-[5px]": shape === "square",
        "rounded-full": shape === "rounded",
      })}
      onClick={() => !disabled && onToggle(!checked)}
    >
      {checked && <CheckIcon color="inherit" fontSize="inherit" />}
    </div>
  );
}
